import { render, staticRenderFns } from "./approveFooter.vue?vue&type=template&id=2d16a334&scoped=true"
import script from "./approveFooter.vue?vue&type=script&lang=js"
export * from "./approveFooter.vue?vue&type=script&lang=js"
import style0 from "./approveFooter.vue?vue&type=style&index=0&id=2d16a334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16a334",
  null
  
)

export default component.exports